export const LEAVE_CREATING_ORDER_MESSAGE = 'Objednávka nebyla dokončena, opravdu chcete stránku opustit?';
